import React, {useState, useContext} from "react";
import Grid from '@material-ui/core/Grid'
import Card from './Card'
import {makeStyles} from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  imageContainer: {
    position: 'absolute',
    top: 20
  },
  bow: {
    width: '100%',
  },
  gridItem: {
    overflow: 'hidden'
  }
}));
export function ProductCarousel(props) {
  let {presents, price, setConfirm, setProduct} = props

  const classes = useStyles()
  return(
      <Grid item container xs={12} spacing={1} justify={'center'} alignItems={'center'} alignContent={'center'}>
        {presents && presents.length > 0 && presents.map((item, i) => {
          return(
            <Grid item xs={12} sm={6} md={4} key={JSON.stringify(item)} className={classes.gridItem}
                  onClick={() => {
              setConfirm(true)
              setProduct({...item, price})
            }}>
              <div className={classes.imageContainer}>
              </div>
              <Card {...item} price={price}/>
            </Grid>
          )})}
      </Grid>
  )
}
